<t4-header></t4-header>
<t4-periodPicker [(from)]="fromDate" [(to)]="toDate" (periodChanged)="loadData()"></t4-periodPicker>
<t4-container>
  <t4-data-table #tbl headline="" matSort reportName="ProductOverviewReport" [parameters]="{from: fromDate, to:toDate}"  [autoGenerateColumns]="false" [filterFields]="">


    <ng-container matColumnDef="Product">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 150px; ">{{ 'Turbo.Reports.ProductOverview.titleProduct' |translate : 'Product' }}</mat-header-cell>
      <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 150px; ">{{row.Product}}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="Count">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 150px; ">{{ 'Turbo.Reports.ProductOverview.titleNumber' |translate : 'Number' }}</mat-header-cell>
      <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 150px; ">{{row.Count}}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="NetAmount">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 150px; ">{{ 'Turbo.Reports.ProductOverview.titleNetAmount' |translate : 'Net Amount' }}</mat-header-cell>
      <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 150px; ">{{row.NetAmount}}</mat-cell>
    </ng-container>



  </t4-data-table>
</t4-container>
